export const formatNumberStringToPrice = (str: string | null | undefined) => {
  if (str == null) return '0.00'

  const [integerPart, decimalPart] = str.split('.')
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return `${formattedInteger}.${decimalPart || '00'}`
}
